import { FONT_WEIGHT } from '@app/styles/themes/constants';
import { Collapse } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
  direction: rtl;
`;

export const Header = styled.div`
  margin-bottom: 0;

  .main-title {
    color: #1a295a;
    margin-bottom: 8px;
    font-size: 20px;
    font-weight: ${FONT_WEIGHT.extremeBold};

    &.font-24 {
      font-size: 24px;
    }
  }

  .sub-text {
    color: #1a295a;
    font-size: 20px;
    font-weight: ${FONT_WEIGHT.light};
  }

  @media screen and (max-width: 768px) {
    margin-bottom: 16px;
    .main-title {
      font-size: 18px;

      &.font-24 {
        font-size: 18px;
      }
    }

    .sub-text {
      font-size: 16px;
    }

    .sub-title {
      font-size: 16px;
    }
  }
`;

export const ContentTextWrapper = styled.div`
  margin-bottom: 0;
  padding-inline-start: 50px;

  &.mt-24 {
    margin-block-start: 24px;
  }

  &.px-0 {
    padding-inline-start: 0;
  }

  .main-title {
    color: #1a295a;
    margin-bottom: 8px;
    font-size: 20px;
    font-weight: ${FONT_WEIGHT.extremeBold};

    &.regular {
      font-weight: ${FONT_WEIGHT.regular};
    }
  }

  .link {
    color: #1a295a;
    margin-bottom: 8px;
    font-size: 20px;
    font-weight: ${FONT_WEIGHT.light};
    text-decoration: underline;
  }

  .mt-16 {
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .mt-0 {
    margin-top: 0;
    margin-bottom: 0;
  }

  .sub-text {
    color: #1a295a;
    font-size: 20px;
    font-weight: ${FONT_WEIGHT.light};

    &.mb-8 {
      margin-block-end: 8px;
    }

    &.mb-24 {
      margin-block-end: 24px;
    }

    &.mb-20 {
      margin-block-end: 20px;
    }
  }

  @media screen and (max-width: 768px) {
    margin-bottom: 16px;
    padding-inline-start: 0px;

    .main-title {
      font-size: 16px;
    }

    .sub-title {
      font-size: 16px;
    }

    .sub-text {
      font-size: 16px;
    }
  }
`;

export const ListWrapper = styled.ul`
  margin-block: 10px;
  padding-inline-start: 20px;

  &.number {
    list-style: none;
    counter-reset: item 0;
    padding: 0;

    li {
      padding-inline-start: 45px;
      position: relative;
      counter-increment: item;
      margin-bottom: 24px;
    }

    li::before {
      content: counter(item);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background-color: #ce6239;
      color: #fff;
      font-weight: bold;
      font-size: 16px;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      position: absolute;
      inset-inline-start: 0; /* position at left */
      top: 20px;
      transform: translateY(-50%); /* vertically center */
    }

    .normal-number {
      list-style: decimal;

      li {
        padding-inline-start: 5px;
        counter-increment: none;
        margin-bottom: 0;
      }

      li::before {
        display: none;
      }
    }
  }

  &.normal-number {
    list-style: decimal;
  }

  @media screen and (max-width: 768px) {
    &.number {
      &:not(.skip) {
        li {
          padding-inline-start: 24px;
        }

        li::before {
          inset-inline-start: -16px;
        }
      }
      .normal-number li {
        padding-inline-start: 0px;
      }
    }
  }
`;

export const ListItem = styled.li`
  font-size: 20px;
  color: #1a295a;
  font-weight: ${FONT_WEIGHT.light};

  @media screen and (max-width: 768px) {
    font-size: 18px;
  }

  @media screen and (max-width: 640px) {
    font-size: 16px;
  }
`;

export const ListTitle = styled.div`
  font-size: 20px;
  color: #1a295a;
  font-weight: ${FONT_WEIGHT.regular};

  @media screen and (max-width: 768px) {
    font-size: 18px;
  }

  @media screen and (max-width: 640px) {
    font-size: 16px;
  }
`;

export const ListContent = styled.div`
  font-size: 20px;
  color: #1a295a;
  font-weight: ${FONT_WEIGHT.light};

  @media screen and (max-width: 768px) {
    font-size: 18px;
  }

  @media screen and (max-width: 640px) {
    font-size: 16px;
  }
`;

export const IconCollapseWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 8px;
  margin-top: 16px;

  .header-text {
    color: #1a295a;
    font-size: 22px;
    font-weight: ${FONT_WEIGHT.extremeBold};
  }

  .plus-icon {
    font-size: 18px;
    color: #ce6239;
    font-weight: ${FONT_WEIGHT.extremeBold};
  }

  .ant-collapse-item.ant-collapse-item-active .ant-collapse-header {
    padding-bottom: 0 !important;
  }

  @media screen and (max-width: 768px) {
    margin-top: 16px;
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;

    .header-text {
      font-size: 18px;
    }

    .plus-icon {
      font-size: 16px;
    }
  }

  @media screen and (max-width: 640px) {
    .header-text {
      font-size: 16px;
    }
  }
`;

export const IconCollapse = styled(Collapse)`
  background: #fbf5f1;
  border-radius: 4px;
  padding: 16px;
  width: 100%;

  .ant-collapse-content .ant-collapse-content-box {
    padding-block-start: 0px;
  }

  &.ant-collapse.ant-collapse-icon-position-start.ant-collapse-rtl.custom-collapse {
    background: transparent;
    padding: 0;
    border: none;
    gap: 16px;
    display: flex;
    flex-direction: column;

    .ant-collapse-item.ant-collapse-no-arrow {
      background: transparent;
      border: none;
      border-bottom: 1px solid #eaecee;
      padding-block: 0;
      border-radius: 0;

      &:last-child {
        border-bottom: none;
      }
    }

    .ant-collapse-header {
      background: transparent;
      border: none;
    }

    .ant-collapse-content {
      //   border-top: 1px solid #eaecee;
      border-top: none;
    }
  }

  @media screen and (max-width: 768px) {
    .ant-collapse-header {
      padding: 12px 12px !important;
    }
  }

  @media screen and (max-width: 640px) {
    .ant-collapse-header {
      padding: 12px 0px !important;
    }
  }
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const IconWrapper = styled.div`
  min-width: 40px;
  width: 40px;
  height: 40px;
  background: #fbf5f1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: ${FONT_WEIGHT.extremeBold};
  border: 2px solid #ce6239;
`;
